const btnHamburger = document.getElementById('bidv-toggle');
const bidvHeader = document.getElementById('bidv-header');
const menuOverlay = document.getElementById('menuOverlay');

if (btnHamburger) {
  btnHamburger.onclick = e => {
    if(bidvHeader.classList.contains('open')) {
      bidvHeader.classList.remove('open');
      menuOverlay.style.animationName = 'fade_out';
      menuOverlay.style.visibility = 'hidden';
      menuOverlay.style.height = '0px';
    } else {
      bidvHeader.classList.add('open');
      menuOverlay.style.animationName = 'fade_in';
      menuOverlay.style.visibility = 'visible';
      menuOverlay.style.height = '100%';
    }
  };
}

// const dropitMenus = document.querySelectorAll(".dropitmenu-submenu");

// dropitMenus.forEach( (dropitMenu) => {
//   if (dropitMenu.childElementCount < 5) {
//     dropitMenu.classList.add('disable-select-org');
//   }
// });

